import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { ButtonWithIcon, Text } from 'common-components'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import * as Styled from './styled'
import { editorSelectors } from 'store/features/editor/selectors'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { convertSizeToAspectRatio } from 'store/features/projectData/utils'
import { dispatch } from 'store'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import AnimateIcon from 'assets/svgr-icons/Animate.svg'
import RemoveIcon from 'assets/svgr-icons/Remove.svg'
import { projectDataThunks } from 'store/features/projectData/thunks'
import ImageContainer from 'components/ImageContainer'
import { normalizeAspectRatio } from 'utils/aspectRatio'
import { isBlobUrl } from 'utils'

const ImageOverlayContent = () => {
  const activeTimelineItem = useSelector(editorSelectors.activeTimelineItem)
  const mediaItems = useSelector(projectDataSelectors.mediaItems)
  const mediaItem = useMemo(
    () => mediaItems.find(item => item.id === activeTimelineItem.id),
    [mediaItems, activeTimelineItem.id]
  )

  const [isImageLoading, setIsImageLoading] = useState(true)

  const imagePath = mediaItem?.meta?.path || ''
  const isBlobImage = isBlobUrl(imagePath)
  const aspectRatio = mediaItem
    ? convertSizeToAspectRatio(mediaItem.width, mediaItem.height)
    : '1:1'

  const normalizedAspectRatio = normalizeAspectRatio(aspectRatio)

  const handleAnimate = () => {
    if (!imagePath || !mediaItem?.id || isBlobImage) return

    dispatch(
      aiVideoThunks.animateImage({
        filePath: imagePath,
        mediaItemId: mediaItem.id,
        assetId: mediaItem.assetId || '',
        isAiImage: false
      })
    )
  }

  const removeItems = () => {
    dispatch(projectDataThunks.removeTimelineSelectedItems())
  }

  if (!imagePath) {
    return null
  }

  return (
    <Styled.Container>
      <Styled.Header>
        <Text type="h1" color="secondaryDark" fontWeight="600">
          {translate(T.EDIT_IMAGE)}
        </Text>
      </Styled.Header>
      <Styled.Content>
        <Styled.ImageWrapper>
          <ImageContainer
            filePath={imagePath}
            isImageLoading={isImageLoading}
            onImageLoad={() => setIsImageLoading(false)}
            aspectRatio={normalizedAspectRatio}
          />
        </Styled.ImageWrapper>
        <Styled.ActionsList>
          <ButtonWithIcon
            isDisabled={isBlobImage}
            icon={<AnimateIcon />}
            label={translate(T.CUSTOM_ANIMATE)}
            onClick={handleAnimate}
          />
          <ButtonWithIcon
            icon={<RemoveIcon />}
            label={translate(T.DELETE_LABEL)}
            onClick={removeItems}
          />
        </Styled.ActionsList>
      </Styled.Content>
    </Styled.Container>
  )
}

export default ImageOverlayContent
